import { OriginalsSection } from '@/components/home/OriginalsSection'
import { PromoBanners } from '@/components/home/PromoBanners'
import { SportsbookSection } from '@/components/home/SportsbookSection'
import { CasinoGamesSection } from '@/components/home/CasinoGamesSection'
import { LeaderboardAndLiveFeed } from '@/components/home/LeaderboardAndLiveFeed'
import { RewardsAndActions } from '@/components/home/RewardsAndActions'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'
import { useGetOriginalGamesQuery } from '@/store/api/originalApi'

export default function Home() {
	const { data: originalGamesResponse, isLoading: isOriginalGamesLoading, isError: isOriginalGamesError } = useGetOriginalGamesQuery()

	return (
		<PageShell gap='8' footer={<Footer />}>
			<OriginalsSection games={originalGamesResponse?.data ?? []} isLoading={isOriginalGamesLoading} isError={isOriginalGamesError} />
			<PromoBanners />
			<SportsbookSection />
			<CasinoGamesSection />
			<LeaderboardAndLiveFeed />
			<RewardsAndActions />
		</PageShell>
	)
}
